import { Typography } from '@mui/material';
import { Link } from '@remix-run/react';

export default function ShowcaseIndex() {
  return (
    <Link to="./TextButton">
      <Typography variant="component-bold-l">
        <code>TextButton</code>
      </Typography>
    </Link>
  );
}
